export const gridIcon = `
  <svg width="40" height="29" viewBox="0 0 40 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="0.940918" width="12" height="12" rx="1.5" stroke="var(--zbp-svg-primary-color, black)"/>
    <rect x="22" y="0.940918" width="12" height="12" rx="1.5" stroke="var(--zbp-svg-primary-color, black)"/>
    <rect x="5" y="15.9409" width="12" height="12" rx="1.5" stroke="var(--zbp-svg-primary-color, black)"/>
    <rect x="22" y="15.9409" width="12" height="12" rx="1.5" stroke="var(--zbp-svg-primary-color, black)"/>
  </svg>
`;
